'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _TextInputContainer = require('../inputs/TextInputContainer');
var _TextInputContainer2 = _interopRequireDefault(_TextInputContainer);
var _inputsStyles = require('../inputsStyles/inputsStyles');
var _styledComponents = require('styled-components');
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
exports.default = function (type) {
  return function (WrappedInput) {
    var InputWithValidation = function (_PureComponent) {
      _inherits(InputWithValidation, _PureComponent);
      function InputWithValidation() {
        var _ref;
        var _temp, _this, _ret;
        _classCallCheck(this, InputWithValidation);
        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }
        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = InputWithValidation.__proto__ || Object.getPrototypeOf(InputWithValidation)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
          showError: false,
          underlineColor: _this.props.isRequired && !_this.props.theme.disabled ? 'color_orange-dark' : 'input_underline_default_color'
        }, _this.getColor = function () {
          var _this$props = _this.props,
            meta = _this$props.meta,
            isRequired = _this$props.isRequired;
          var valid = meta.valid;
          var color = 'input_underline_default_color';
          if (isRequired) {
            color = valid ? 'color_green' : 'color_red';
          }
          return color;
        }, _this.isErrorVisible = function () {
          var _this$props2 = _this.props,
            meta = _this$props2.meta,
            isRequired = _this$props2.isRequired;
          var invalid = meta.invalid;
          var showError = false;
          if (isRequired) {
            showError = invalid;
          }
          return showError;
        }, _this.onBlur = function () {
          var showError = _this.isErrorVisible();
          var color = _this.getColor();
          if (_this.state.underlineColor === 'color_orange-dark') {
            _this.setState({
              showError: showError,
              underlineColor: color
            });
          }
        }, _this.onChange = function (event) {
          var value = event.target.value;
          var onChange = _this.props.input.onChange;
          onChange(value);
        }, _this.handleWrappedInputProps = function () {
          var _this$props3 = _this.props,
            input = _this$props3.input,
            isRequired = _this$props3.isRequired,
            placeholder = _this$props3.placeholder,
            disabled = _this$props3.theme.disabled;
          var value = input.value,
            name = input.name;
          var props = {
            id: name,
            name: name,
            value: value,
            onChange: _this.onChange,
            onBlur: _this.onBlur,
            placeholder: placeholder,
            required: isRequired,
            disabled: disabled
          };
          if (type === 'maskedText') {
            return Object.assign({}, props, {
              mask: _this.props.regex,
              moneyMask: _this.props.moneyMask
            });
          }
          if (type === 'select') {
            return Object.assign({}, props, {
              options: _this.props.options
            });
          }
          return props;
        }, _temp), _possibleConstructorReturn(_this, _ret);
      }
      _createClass(InputWithValidation, [{
        key: 'render',
        value: function render() {
          var _props = this.props,
            input = _props.input,
            meta = _props.meta,
            label = _props.label,
            size = _props.size,
            customstyle = _props.customstyle,
            after = _props.after;
          return _react2.default.createElement(_TextInputContainer2.default, {
            label: label,
            htmlFor: input.name,
            size: size,
            type: type,
            customstyle: customstyle
          }, _react2.default.createElement(_inputsStyles.InputColContainer, {
            underlinecolor: this.state.underlineColor
          }, _react2.default.createElement(WrappedInput, this.handleWrappedInputProps())), this.state.showError && _react2.default.createElement(_inputsStyles.StyledErrorSpan, null, meta.error), meta.warning !== undefined && _react2.default.createElement(_inputsStyles.StyledErrorSpan, null, meta.warning), after);
        }
      }], [{
        key: 'getDerivedStateFromProps',
        value: function getDerivedStateFromProps(nextProps, prevState) {
          var meta = nextProps.meta,
            isRequired = nextProps.isRequired,
            disabled = nextProps.theme.disabled;
          var dirty = meta.dirty,
            valid = meta.valid,
            invalid = meta.invalid,
            initial = meta.initial;
          if (disabled) {
            return null;
          }
          if (isRequired) {
            var underlineColor = prevState.underlineColor;
            var showError = prevState.showError;
            var isFieldInitialized = initial !== undefined;
            if (isFieldInitialized) {
              underlineColor = valid ? 'color_green' : 'color_red';
              showError = invalid;
            } else if (underlineColor !== 'color_orange-dark' || dirty) {
              underlineColor = valid ? 'color_green' : 'color_red';
              showError = invalid;
            }
            return {
              underlineColor: underlineColor,
              showError: showError
            };
          }
          return null;
        }
      }]);
      return InputWithValidation;
    }(_react.PureComponent);
    ;
    return (0, _styledComponents.withTheme)(InputWithValidation);
  };
};